/**
 * Serializes a single entity from a GraphQL node.
 * @param {Object} node - The entity node from the GraphQL response.
 * @returns {Object} - Serialized entity object.
 */
export const serializeItem = (node) => {
    if (!node) return null;

    const serializedBook = {
        id: node.id,
        dbId: node.dbId,
        title: node.title,
        genre: node.genre,
        imageUrl: node.imageUrl,
        visibility: node.visibility,
        description: node.description,
        isbn: node.isbn,
        publicationYear: node.publicationYear,
        author: node.authors?.map(a => a.name).join(', ') || '',
        publisher: node.publisher?.name || null,
        entities: [],
        isReserved: false,
        isReservedMe: false,
        isBorrowed: false,
        isBorrowedMe: false,
        isHolded: false,
        isHoldedMe: false,
        states: '',
        entity: null
    };

    const userId = localStorage.getItem('uid');
    const entityStates = [];

    if (node.entities?.length) {
        let fallbackEntityWithoutStates = null;

        node.entities.forEach((entity) => {
            serializedBook.entities.push(entity);

            let hasUserEntityState = false;

            entity.entityStates?.forEach((state) => {
                entityStates.push(state);

                if (state.state === 'RESERVED') {
                    if (state.userId === userId) {
                        serializedBook.isReservedMe = true;
                        hasUserEntityState = true;
                    }
                }
                if (state.state === 'BORROWED') {
                    if (state.userId === userId) {
                        serializedBook.isBorrowedMe = true;
                        hasUserEntityState = true;
                    }
                }
                if (state.state === 'ON_HOLD') {
                    if (state.userId === userId) {
                        serializedBook.isHoldedMe = true;
                        hasUserEntityState = true;
                    }
                }
            });

            if (hasUserEntityState && !serializedBook.entity) {
                serializedBook.entity = entity;
            }

            if (!entity.entityStates?.length && !fallbackEntityWithoutStates) {
                fallbackEntityWithoutStates = entity;
            }
        });

        if (!serializedBook.entity) {
            const fallbackEntity = node.entities.find(e =>
                !e.entityStates?.length ||
                e.entityStates?.some(s => s.state === 'RESERVED')
            );
            serializedBook.entity = fallbackEntity || node.entities[0];
        }

        // Determine global status flags based on entity ownership
        const checkEntity = serializedBook.entity;

        if (checkEntity?.entityStates?.length) {
            checkEntity.entityStates.forEach((state) => {
                if (state.state === 'RESERVED') {
                    serializedBook.isReserved = true;
                }
                if (state.state === 'BORROWED') {
                    serializedBook.isBorrowed = true;
                }
                if (state.state === 'ON_HOLD') {
                    serializedBook.isHolded = true;
                }
            });
        }
    }

    serializedBook.states = entityStates.map(s => s.state).join(', ');

    return serializedBook;
};

/**
 * Serializes entities from GraphQL response edges.
 * @param {Array} edges - Array of edges from the GraphQL response.
 * @returns {Array} - Array of serialized entities.
 */
export const serializeBooks = (edges) => {
    return edges.map(({ node }) => serializeItem(node));
};
